import type { FlightType } from "@/types/flights";
import { useTranslations } from "next-intl";
import { getFlightTypeOptions } from "./useSearchFlights";
import { RadioDropdown } from "./RadioDropdown/RadioDropdown";

const isFlightType = (value: unknown): value is FlightType => {
  return value === "rounded" || value === "one_way" || value === "multi_city";
};

const getValue = (value: string): FlightType => {
  return isFlightType(value) ? value : "rounded";
};

type Props = {
  value: FlightType;
  onChange: (flightType: FlightType) => void;
  className?: string;
  isFullScreenModal?: boolean;
};

const FlightTypeDropdown = ({
  value,
  onChange,
  className,
  isFullScreenModal,
}: Props) => {
  const t = useTranslations();

  return (
    <div>
      <div className="flex gap-x-1 sm:hidden">
        {getFlightTypeOptions(t).map((option) => (
          <button
            className={`py-1.5 rounded-full text-sm font-semibold h-8 font-switzer w-1/3 text-nowrap ${value === option.value ? "bg-sleap-purple-300 text-white" : "bg-sleap-gray-50 text-sleap-gray-950"}`}
            key={option.value}
            onClick={() => onChange(getValue(option.value))}
          >
            {option.label}
          </button>
        ))}
      </div>
      <div className="sm:block hidden">
        <RadioDropdown
          value={value}
          options={getFlightTypeOptions(t)}
          name="flightType"
          id="flight-type"
          onChange={(value) => onChange(getValue(value))}
          className={className}
          title="Flight type"
          isFullScreenModal={isFullScreenModal}
        />
      </div>
    </div>
  );
};

export default FlightTypeDropdown;
